angular.module('components.caMapOrSelect', [])
    .component('caMapOrSelect', {
        templateUrl: 'main/product/productimport/components/maporselect.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            choices: '<',
            choiceModel: '=',
            choiceOrderBy: '<',
            choiceItemRenderer: '<',
            choiceFilterBy: '<',
            choicePlaceholder: '<',
            columnNames: '<',
            columnModel: '=',
            columnOrderBy: '<',
            columnItemRenderer: '<',
            columnFilterBy: '<',
            columnPlaceholder: '<',
            disabledBy: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope, GenericComponentService) {
    var vm = this;
    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    //Properties
    vm.multiplicity = 'single';
    vm.mandatory = true;

    //Methods
    vm.filterChoice = filterChoice;
    vm.filterColumn = filterColumn;

    function onInit() {
        resolveRenderer();

        $scope.$watch(function() { return (vm.multiplicity); }, function(oldValue, newValue) {
            if (oldValue !== newValue) {
                if (vm.multiplicity === 'single') {
                    vm.columnModel = undefined;
                } else if (vm.multiplicity === 'multiple') {
                    vm.choiceModel = undefined;
                }
            }
        });
    }

    function onChanges(changes) {
        if (changes.choiceRenderItem || changes.columnRenderItem) {
             resolveRenderer();
        }
    }

    function resolveRenderer() {
        vm.choiceRenderItem = GenericComponentService.resolveSelectRenderer(vm.choiceItemRenderer);
        vm.columnRenderItem = GenericComponentService.resolveSelectRenderer(vm.columnItemRenderer);
    }

    function filterChoice(query) {
        return GenericComponentService.getSelectFilter(query, vm.choiceFilterBy);
    }
    function filterColumn(query) {
        return GenericComponentService.getSelectFilter(query, vm.columnFilterBy);
    }
}
